import React from "react";

type TextWrapProps = {
  color?: string;
};

const TextWrap: React.FC<TextWrapProps> = ({ color = "#000" }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 20V4H6V20H4ZM18 20V4H20V20H18ZM10.6 17.55L7.05 14L10.6 10.475L12 11.875L10.875 13H13C13.55 13 14.021 12.804 14.413 12.412C14.8043 12.0207 15 11.55 15 11C15 10.45 14.8043 9.979 14.413 9.587C14.021 9.19567 13.55 9 13 9H7V7H13C14.1 7 15.0417 7.39167 15.825 8.175C16.6083 8.95833 17 9.9 17 11C17 12.1 16.6083 13.0417 15.825 13.825C15.0417 14.6083 14.1 15 13 15H10.875L12 16.125L10.6 17.55Z"
        fill={color}
      />
    </svg>
  );
};

export default TextWrap;
